export const capitalizeFirstLetter = (str:string) => {
    return `${str?.[0]?.toUpperCase()}${str?.slice(1)}`;
  };

export const formatCommaSeparatedStrings = (string:string)=>{
  const strings = string?.split(',')?.map(e=> capitalizeFirstLetter(e))
  return strings?.join(',')?.replace(/,/g, ', ')
}

export const getPlatform = () => {
  const userAgent = navigator.userAgent;
  
  // Check for iOS devices in browser
  const isIOSBrowser = /iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream;
  
  // More comprehensive iOS check (handles iPadOS 13+ that reports as Mac)
  const isIOSDevice = (
    (/iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream) 
  );
  
  const isAndroid = /Android/.test(userAgent);

  return (isIOSDevice || isIOSBrowser)
   ? 'ios' : isAndroid ? 'android' : 'desktop';
};

export const share = async ({ title, text, url }: { title?: string; text: string; url: string }) => {
    const platform = getPlatform();
  try {
    // For now only share to whats app for IOS due to limitations with web share API on iOS
    if (platform === 'ios') {
      const message = `${text || title} ${url.toString()} `;

      const wa = `https://wa.me/?text=${encodeURIComponent(message)}`;
      window.open(wa, '_blank');
      return { success: true };
    }

    if (navigator.share && navigator.canShare({ url })) {
      await navigator.share({ title, text, url });
      return { success: true };
    } else {
      // Fallback for browsers that don't support the Web Share API
      navigator.clipboard.writeText(url);
      return { success: false, error: 'Web Share API not supported' };
    }
  } catch (error) {
    return { success: false, error: (error as Error).message };
  }
};



